import { GET_ANALYTICS_INFO } from '../../constants';

export interface AnalyticsInfo {
  gtmId?: string;
  enabled?: boolean;
}

export interface AnalyticsState {
  data: AnalyticsInfo | null;
  loaded: boolean;
}

const initialState: AnalyticsState = {
  data: null,
  loaded: false,
};

export const analyticsReducer = (
  state = initialState,
  action: { type?: string; result?: any } = {},
): AnalyticsState => {
  switch (action.type) {
    case `${GET_ANALYTICS_INFO}_SUCCESS`:
      return { data: action.result || {}, loaded: true };

    case `${GET_ANALYTICS_INFO}_FAIL`:
      return { data: null, loaded: true };

    default:
      return state;
  }
};

export default analyticsReducer;
